import { useQuery } from "react-query";
import { getAgreementsCount } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useAgreementsCount = () => {
  return useQuery("GetAgreementsCount", getAgreementsCount, {
    refetchOnWindowFocus: false,
  });
};

export default useAgreementsCount;
